import { useEffect } from "react";

export const useEditorRefSynchronization = ({
  refReusableTextIdsArray,
  reusableTextIdsArray,
  refClaimsArray,
  claimsArray,
  refDroppedComponentIds,
  droppedComponentIds,
  refDroppedTextIdsArray,
  droppedTextIds,
  refDroppedComponentTextIds,
  droppedComponentTextIds,
  tempLayer,
  layerCompData,
  tempSelect,
  selectedComponent,
  refMultiselected,
  multiSelectedComps,
  animationObjRef,
  animationObject,
  compCountRef,
  count,
  copiedComponentRef,
  copiedComponent,
  refCountZindex,
  countZindex,
  setAnimationObject,
}) => {
  useEffect(() => {
    refReusableTextIdsArray.current = reusableTextIdsArray;
    refClaimsArray.current = claimsArray;
    refDroppedComponentIds.current = droppedComponentIds;
    refDroppedTextIdsArray.current = droppedTextIds;
    refDroppedComponentTextIds.current = droppedComponentTextIds;
    tempLayer.current = layerCompData;
    tempSelect.current = selectedComponent;
    refMultiselected.current = multiSelectedComps;
    animationObjRef.current = animationObject;
    compCountRef.current = count;
    copiedComponentRef.current = copiedComponent;
    refCountZindex.current = countZindex;

    if (Object.entries(animationObject).length > 0) {
      const validAnimationKeys = new Set(
        layerCompData.map((layer) => layer.id).filter(Boolean)
      );

      layerCompData.forEach((layer) => {
        if (layer?.componentType !== "Image") return;
        const hitAreas = layer?.componentStyles?.hitAreas;
        if (!Array.isArray(hitAreas)) return;
        hitAreas.forEach((hitArea) => {
          if (hitArea?.id) validAnimationKeys.add(hitArea.id);
        });
      });

      const orphanKeys = Object.keys(animationObject).filter(
        (key) => !validAnimationKeys.has(key)
      );

      if (orphanKeys.length > 0) {
        const tempAnimationObj = {};
        for (const props in animationObject) {
          if (validAnimationKeys.has(props)) {
            tempAnimationObj[props] = animationObject[props];
          }
        }
        setAnimationObject(tempAnimationObj);
      }
    }
  }, [
    layerCompData,
    selectedComponent,
    multiSelectedComps,
    animationObject,
    count,
    copiedComponent,
    countZindex,
  ]);
};
